import {
    SCHEDULED_VIDEO_SHOWS_PATH,
    SCHEDULED_RADIO_SHOWS_PATH,
} from "../constants/CurationUrls";
import { LIVE, AUDIO } from "../constants/StreamTypes";
import { COJP_PATH } from "../constants/Sites";

function getShowScheduleUrl(channelId) {
    return `${SCHEDULED_VIDEO_SHOWS_PATH}/${channelId}`;
}

function getRadioShowScheduleUrl(channelId) {
    return `${SCHEDULED_RADIO_SHOWS_PATH}/${channelId}`;
}

// TODO(ENG4VIDEO-5177) : clean this up after the /jp is completely rolled out
function getLiveStreamUrl(channelId, cojpPath) {
    if (cojpPath === COJP_PATH) {
        return `/jp/live/${channelId}`;
    }

    return `/live/${channelId}`;
}

function getRadioStreamUrl(channelId) {
    return `/audio/${channelId}`;
}

function getStreamUrl({ type = LIVE, channelId, cojpPath }) {
    if (type === LIVE) {
        return getLiveStreamUrl(channelId, cojpPath);
    }

    if (type === AUDIO) {
        return getRadioStreamUrl(channelId);
    }
}

export {
    getShowScheduleUrl,
    getRadioShowScheduleUrl,
    getLiveStreamUrl,
    getRadioStreamUrl,
    getStreamUrl,
};
